import { Box, Typography, Avatar } from "@mui/material";

const InfoItem = ({ icon: Icon, label, value, color = "#0f172a", mb = 3 }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', mb }}>
        <Avatar sx={{ bgcolor: (theme) => `${theme.palette.primary.main}33`, color: 'primary.main', mr: 2, width: 44, height: 44 }}>
            {Icon && <Icon sx={{ fontSize: 22 }} />}
        </Avatar>
        <Box>
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', mb: 0.5 }}>
                {label}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, color, fontSize: '0.95rem' }}>
                {value || '—'}
            </Typography>
        </Box>
    </Box>
);

export default InfoItem;
